import {Component, HostListener, OnDestroy, OnInit} from '@angular/core';
import {ActivatedRoute, Data, Router} from '@angular/router';
import {MatDialog, MatDialogRef} from '@angular/material/dialog';
import {Title} from '@angular/platform-browser';
import {TranslateService} from '@ngx-translate/core';
import {TieuChuan} from '@entities/tieu-chuan/tieu-chuan.model';
import {JhiEventManager} from 'ng-jhipster';
import {TieuChuanService} from '@entities/tieu-chuan/tieu-chuan.service';

@Component({
  selector: 'app-tieu-chuan-delete-dialog',
  templateUrl: './tieu-chuan-delete-dialog.component.html',
})
export class TieuChuanDeleteDialogComponent {
  standard: TieuChuan;

  @HostListener('window:keyup.esc')
  private onKeyUp() {
    this.dialogRef.close();
  }
  constructor(
    private dialogRef: MatDialogRef<TieuChuanDeleteDialogComponent>,
    private eventManager: JhiEventManager,
    private tieuchuanService: TieuChuanService,
  ) {}

  confirmDelete(id: any) {
    this.tieuchuanService.delete(id).subscribe((response) => {
      this.eventManager.broadcast({
        name: 'tieuChuanListModification',
        content: 'TieuChuan',
      });
      this.dialogRef.close(true);
    });
  }
}

@Component({
  selector: 'app-tieu-chuan-delete-popup',
  template: '',
})
export class TieuChuanDeletePopupDiaglogComponent implements OnInit, OnDestroy {
  private dialogRef: MatDialogRef<TieuChuanDeleteDialogComponent>;
  constructor(
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private dialog: MatDialog,
    private titleService: Title,
    private translate: TranslateService,
  ) {}

  ngOnInit() {
    this.titleService.setTitle(
      this.translate.instant(
        'entities.tieu-chuan.tieu-chuan-delete-dialog.Xóa quy trình_title',
      ),
    );
    this.activatedRoute.data.subscribe(({tieuchuan}: Data) => {
      setTimeout(() => {
        this.dialogRef = this.dialog.open(TieuChuanDeleteDialogComponent, {
          disableClose: true,
          width: '380px',
        });
        this.dialogRef.componentInstance.standard = tieuchuan;
        this.dialogRef.afterClosed().subscribe(
          (result) => {
            this.router.navigate([{outlets: {popup: null}}], {
              replaceUrl: true,
              queryParamsHandling: 'merge',
            });
          },
          (reason) => {
            this.router.navigate([{outlets: {popup: null}}], {
              replaceUrl: true,
              queryParamsHandling: 'merge',
            });
          },
        );
      }, 0);
    });
  }
  ngOnDestroy() {
    this.titleService.setTitle(
      this.translate.instant(
        'entities.tieu-chuan.tieu-chuan-delete-dialog.Danh sách quy trình_title',
      ),
    );
    this.dialogRef = null;
  }
}
